import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { hasConsentedToCookies } from "./helpers/cookies";
import { getSegmentUserId, identify, page, track } from "./library";
var noop = function() {
    return {};
};
var defaultValues = {
    trackEvent: noop,
    getSegmentUserId: function() {
        return "";
    }
};
var CustomerDataContext = /*#__PURE__*/ createContext(defaultValues);
export var useCustomerData = function() {
    return useContext(CustomerDataContext);
};
export var trackEvent = function(event) {
    if ("object" !== "undefined") {
        if (!hasConsentedToCookies("functional")) {
            return;
        }
        switch(event.type){
            case "identify":
                if (event.userId) {
                    identify({
                        userId: event.userId,
                        data: event.data || {}
                    });
                } else {
                    identify({
                        data: event.data || {}
                    });
                }
                break;
            case "track":
                track(event.eventName, event.data);
                break;
            case "page":
                page(event.pageName, event.data);
                break;
        }
    }
};
export var CustomerDataProvider = function(param) {
    var children = param.children;
    var context = {
        trackEvent: trackEvent,
        getSegmentUserId: getSegmentUserId
    };
    return /*#__PURE__*/ _jsx(CustomerDataContext.Provider, {
        value: context,
        children: children
    });
};
